import { render, staticRenderFns } from "./NaviGation_VideoScript.vue?vue&type=template&id=6e8168b3&scoped=true"
import script from "./NaviGation_VideoScript.vue?vue&type=script&lang=js"
export * from "./NaviGation_VideoScript.vue?vue&type=script&lang=js"
import style0 from "./NaviGation_VideoScript.vue?vue&type=style&index=0&id=6e8168b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8168b3",
  null
  
)

export default component.exports